export enum MonthClosingReportType {
  MONTH_CLOSING_MISSING_INVOICES = 'MONTH_CLOSING_MISSING_INVOICES',
}
